import { render } from "./deleteRecords.vue?vue&type=template&id=70fe6087&scoped=true"
import script from "./deleteRecords.vue?vue&type=script&lang=js"
export * from "./deleteRecords.vue?vue&type=script&lang=js"

import "./deleteRecords.vue?vue&type=style&index=0&id=70fe6087&scoped=true&lang=css"
import "./deleteRecords.vue?vue&type=style&index=1&id=70fe6087&lang=css"
script.render = render
script.__scopeId = "data-v-70fe6087"

export default script